import React from "react";
import "./Checkouts.css";
import logo from "../assets/images/logo.svg";
export default function Checkouts() {
  return (
    <main className="checkouts-container">
      <section className="checkouts-container-left">
        <div style={{ width: "60%", margin: "auto" }}>
          <h2 style={{ marginBottom: "1rem",fontSize: "30px",color:"rgb(69, 69, 69)"}}>Complete your purchase</h2>
          <h5  style={{ marginBottom: "1rem",fontSize: "20px"}}>Where are you located?</h5>
          <p>
            Please enter your Country and Post/ ZIP Code below. We collect this
            information to help combat fraud, and to keep your payment secure.
          </p>

          <button
            style={{
              margin: "10px",
              width: "40%",
              height: "40px",
              border: "none",
              backgroundColor: "rgb(0, 150, 255)",
              borderRadius: "3px",
              color :"#fff",
              fontSize: "18px", 
              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
            Checkout
          </button>
          <div
            style={{
              border: "1px solid #eee",
              fontSize: "12px",
              // marginTop: "10px",
              
            }}
          >
            <p style={{ margin: "auto" ,padding : "5px",color:"rgb(69, 69, 69)"}}>
              This order process is conducted by our online reseller & Merchant
              of Record, Paddle.com, who also handle order related inquiries and
              returns.
            </p>
            <p style={{ margin: "auto",padding : "5px" ,color:"rgb(69, 69, 69)"}}>
              Your data will be shared with Kaleido AI GmbH for product
              fulfilment. Paddle.com Market Ltd, Judd House, 18-29 Mora Street,
              London EC1V 8BT
            </p>
          </div>
        </div>
      </section>
      <section className="checkouts-container-right">
        <img
          src={logo}
          alt="#"
          style={{ width: "250px", height: "40px", margin: "5rem" }}
        />
        <div style={{ marginBottom: "1rem" }}>
          <p style={{ fontSize: "22px", fontWeight: "bold" }}>
            Your subscription
          </p>
          <span
            style={{
              fontSize: "12px",
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: "italic",
            }}
          >
            Change
          </span>
        </div>
        <div style={{ marginBottom: "0.5rem" }}>
          <p>200 credits per month</p>
          <span>$39.00</span>
        </div>
        <div tyle={{ marginBottom: "0.5rem" }}>
          <p>Sales tax</p>
          <span>$0.00</span>
        </div>

        <div
          style={{
            marginTop: "0.5rem",
            borderTop: "1px solid #ddd",
            borderBottom: "1px solid #ddd",
            fontSize: "30px",
            fontWeight: "bold",
          }}
        >
          <p>Total</p>
          <span>$39.00</span>
        </div>

        <div className="checkouts-container-bottom">
          <div>
            <i class="fa-solid fa-circle-check"></i>
            <p> Risk free:14 Days Money Back Guarantee</p>
          </div>
          <div>
            <i class="fa-solid fa-circle-check"></i>
            <p> Flexible:Downgrade, upgrade or cancel any time</p>
          </div>
          <div>
            <i class="fa-solid fa-circle-check"></i>
            <p>Fair:Unused credits roll over</p>
          </div>
        </div>
      </section>
    </main>
  );
}
